__turbopack_context__.v({
  "closeButton": "Drawer-module__LM5GZW__closeButton",
  "closeButtonAbsolute": "Drawer-module__LM5GZW__closeButtonAbsolute",
  "content": "Drawer-module__LM5GZW__content",
  "dialog": "Drawer-module__LM5GZW__dialog",
  "dialogInDesktop": "Drawer-module__LM5GZW__dialogInDesktop",
  "header": "Drawer-module__LM5GZW__header",
  "modal": "Drawer-module__LM5GZW__modal",
  "modal-fade": "Drawer-module__LM5GZW__modal-fade",
  "modal-slideacross": "Drawer-module__LM5GZW__modal-slideacross",
  "modal-slideup": "Drawer-module__LM5GZW__modal-slideup",
  "modalAsDialog": "Drawer-module__LM5GZW__modalAsDialog",
  "modalDesktop": "Drawer-module__LM5GZW__modalDesktop",
  "modalOverlay": "Drawer-module__LM5GZW__modalOverlay",
  "noResizeOnTouchKeyboard": "Drawer-module__LM5GZW__noResizeOnTouchKeyboard",
  "survey": "Drawer-module__LM5GZW__survey",
  "title": "Drawer-module__LM5GZW__title",
});
